import React from 'react';
import Section from '../Section/Section';
import { certifications } from '../../data/portfolioData';

export const Credentials = () => (
  <Section id="credentials" path="credentials" title="Certifications and leadership">
    <dl className="kv-list">
      {certifications.map((item) => (
        <div className="kv-row" key={item.id}>
          <dt>{item.title}</dt>
          <dd>{item.detail}</dd>
        </div>
      ))}
    </dl>
  </Section>
);

export default Credentials;
